import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NtError } from '../models/auth-models';
import { HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

export const authInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const router = inject(Router);
    const snackBar = inject(MatSnackBar);
    const token = sessionStorage.getItem('token');

    let authReq = req;
    if (token) {
        authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
                router.navigateByUrl('/login');
            }
            const msg = error.error?.message ?? `${error.statusText} : ${error.message}`;
            snackBar.open('Mensaje: ' + msg, 'Cerrar', {
                duration: 10000,
                panelClass: ['snackbar-error']
            });
            return throwError(() => new NtError(msg, error.error));
        })
    );
};
